module.exports = __webpack_public_path__ + "static/media/preview_earning_campaigns_6.789737ca.svg";